<template>
    <el-row>
        <el-col :span="24" align="center">
            <sm-lottie filename="empty_sm-lottie.json" />
            <div class="bg-grey100 rounded border pa-4">
                <span class="font-weight-bold text-subtitle-1 text-medium-emphasis pa-4">{{$t('No Available Data')}}</span>
            </div>
        </el-col>
    </el-row>
</template>

<script>
    export default{}
</script>